import axios from "axios";
import { kg } from "@/data/media";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const imgSrc = (s) => {
  if (!s) return "";
  if (s.startsWith("/api/")) return `${BACKEND}${s}`;
  if (s.startsWith("/") || s.startsWith("http")) return s;
  return kg(s);
};

export const money = (n) =>
  n == null ? "Price on request" : `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
